import { Box, capitalize, Divider, Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import ZahllaufPivotTable from "../../components/zahllauf/ZahllaufPivotTable";
import React, { useState } from "react";
import { ZahllaufProvider } from "../../contexts/ZahllaufContext";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import Guard from "../../components/Guard";
import { formatAsMoney } from "../../formatterHelpers";

function ZahllaufPivotListe() {
  const storedLimit = Number(localStorage.getItem("zahllaufLimit"));
  const limit =
    Number.isInteger(storedLimit) && storedLimit >= 1 && storedLimit <= 1000
      ? storedLimit
      : 300;
  const [anzahlAlleRechnungen, setAnzahlAlleRechnungen] = useState<number>(0);
  const [summeAlleRechnungen, setSummeAlleRechnungen] = useState<number>(0);
  const [anzahlSelectedRechnungen, setAnzahlSelectedRechnungen] =
    useState<number>(0);
  const [summeSelectedRechnungen, setSummeSelectedRechnungen] =
    useState<number>(0);
  const [alleRechnungen, setAlleSelectedRechnungen] = useState<string[]>([]);
  const { t: translation } = useT("zahllauf");
  return (
    <ZahllaufProvider>
      <Layout title={translation("paymentruns-pivot")} showTitleInNav={false}>
        <Guard
          permission={"zahllauf:list"}
          fallback={<ErrorAlert error={notPermitted()} />}
        >
          <Paper
            elevation={1}
            sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
          >
            <Typography variant="h5">
              {translation("paymentruns-pivot")}
            </Typography>
            <ZahllaufPivotTable
              setAnzahlAlleRechnungen={setAnzahlAlleRechnungen}
              setSummeAlleRechnungen={setSummeAlleRechnungen}
              setAnzahlSelectedRechnungen={setAnzahlSelectedRechnungen}
              setSummeSelectedRechnungen={setSummeSelectedRechnungen}
              setAlleSelectedRechnungen={setAlleSelectedRechnungen}
              alleRechnungen={alleRechnungen}
              limit={limit}
            />
            <Box
              display={"grid"}
              sx={{
                gridTemplateColumns: ["1fr", "2fr 1fr 1fr"],
                gap: 2,
              }}
            >
              <>
                <p></p>
              </>
              <Paper elevation={1} sx={{ marginTop: 2, padding: 3 }}>
                <Box
                  display={"flex"}
                  sx={{
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>
                    {anzahlSelectedRechnungen.toFixed(0)} gewählt
                  </Typography>
                  <Divider orientation="vertical" flexItem />
                  <Typography>
                    {formatAsMoney(summeSelectedRechnungen)}
                  </Typography>
                </Box>
              </Paper>
              <Paper elevation={1} sx={{ marginTop: 2, padding: 3 }}>
                <Box
                  display={"flex"}
                  sx={{
                    justifyContent: "space-between",
                    color: "grey",
                  }}
                >
                  <Typography>
                    {anzahlAlleRechnungen.toFixed(0)} gesamt
                  </Typography>
                  <Divider orientation="vertical" flexItem />
                  <Typography>{formatAsMoney(summeAlleRechnungen)}</Typography>
                </Box>
              </Paper>
            </Box>
          </Paper>
        </Guard>
      </Layout>
    </ZahllaufProvider>
  );
}

export default ZahllaufPivotListe;
